exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table .success-row{background:#e6fdfd}", ""]);

// exports
